<script>
	import { page } from '$app/state';
    import { scrollToSection } from '../../utils/scroll-to-section';
	import HamburgerButton from './HamburgerButton.svelte';

	let menuOpen = $state(false);

	const menuItems = [
		{
			path: '/#o-kancelarii',
			label: 'O kancelarii',
			onClick: () => scrollToSection('o-kancelarii'),
			external: true
		},
		{
			path: '/czynnosci-notarialne',
			label: 'Czynnosci notarialne'
		},
		{
			path: '/oplaty-i-platnosci',
			label: 'Oplaty i platnosci'
		},
		{
			path: '/#kontakt',
			label: 'Kontakt',
			onClick: () => scrollToSection('kontakt'),
			external: true
		}
	]
</script>

<header class="header">
	<div class="container header__container">
		<div class="logo-container">
			<a href="/" class="logo-link">
				<img class="logo-icon" src="/logo-icon.png" alt="WW Notariusz logo ikona" />
				<img class="logo" src="/logo.svg" alt="WW Notariusz logo">
			</a>
		</div>

		<HamburgerButton bind:menuOpen={menuOpen} on:click={(e) => menuOpen = e.detail.isOpen}/>

		<nav class="menu" class:show={menuOpen}>
		  <div class="" class:show={menuOpen} id="navbarNav">
			<ul class="menu__list">
				{#each menuItems as item}
					<li class="menu__list-item">
						<a 
							class="menu__link" 
							aria-current={page.url.pathname === item.path || page.url.hash === item.path.slice(1) ? 'page' : undefined} 
							href="{item.path}"
							onclick={() => { menuOpen = false; item.onClick && item.onClick(); }}
							rel={item.external ? 'external' : ''}
						>
							{item.label}
						</a>
					</li>
				{/each}
			</ul>
		  </div>
		</nav>
	</div>
</header>

<style>
	.header {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		background: var(--color-theme-1);
		color: #FFF;
		padding: 1.25rem 0;
	}

	.header__container {
		display: flex;
		justify-content: space-between;
		align-items: center;	
		flex-wrap: wrap;
	}

	.logo-container {
		height: 100%;
	}

	.logo-link {
		display: flex;
		gap: 1rem;
		text-decoration: none;
	}

	.logo {
		width: 200px;
	}

	.logo-icon {
		width: 50px;
	}

	.menu {
		display: none;
		width: 100%;
	}

	.menu.show {
		display: block;
	}

	.menu__list {
		display: block;
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.menu__list-item {
		display: flex;
		align-items: center;
		padding: 0;
		margin: 0;
		text-transform: uppercase;
		font-weight: 300;
	}

	.menu__link {
		display: block;
		padding: 0.75rem 0rem;
		color: #FFF;
		text-decoration: none;
		font-size: 1rem;
	}
	
	.menu__link[aria-current="page"] {
		color: #f3dba5;
	}

	@media (min-width: 768px) {

		.logo {
			width: 250px;
		}

		.menu {
			display: block;
			width: auto;
		}

		.menu__list {
			display: flex;
			gap: 1rem;
		}

		.menu__link {
			border-bottom: 2px solid transparent;
		}

		.menu__link[aria-current="page"] {
			border-color: var(--color-theme-1);
		}
	}
</style>
